const es = {
  lang: "es",
  home: "GENERAL",
  welcomeText:
    "Hola, soy Luka Rostomashvili y os ofrezco asesoría en derecho, las clases de Español, los servicios de visa y también traducción, junto con el curso de carnet de conducir",
  services: "SERVICIOS",
  lawyer: "ABOGADO",
  academy: "LUKA ACADEMY",
  visa: "EL SERVICIO DE VISADO ESTADOS UNIDOS",
  driver: "LA LICENCÍA DE CONDUCIR",
  translate: "TRADUCTOR",
  aboutMe: "SOBRE MÍ",
  aboutMeText:
    "yo soy abogado, con los estudios también de español como profesor y de marketing digital. También ofrezco los servicios de traducción y los cursos de carnet de conducir",
  education: "EDUCACIÓN",
  educationText:
    "RECIBÍ LA EDUCACIÓN EN LA UNIVERSIDAD DE BARCELONA Y DE ALICANTE",
  achievement: "LOGROS",
  contact: "CONTACTO",
  recomendations: "RECOMENDACION",
  recomendation_one: "GRACIAS LUKA POR TU ASESORÍA JURIDICA, LO RECOMIENDO",
  recomendation_two:
    "MUCHAS GRACIAS POR EL APOYO A LUKA, ÉL ES UN AUTENTICO PROFESIONAL Y LO RECOMIENDO",
};

export default es;
